import { actionTypesHubspot as actionTypes } from "../constants/actionTypesHubspot";
import { hubspotState } from "../state/hubspot";

const hubspotReducer = (state = hubspotState, action: any) => {
  switch (action.type) {
    case actionTypes.ListOfCompanies:
      return {
        ...state,
        companiesList: action.payload,
        isCompaniesListLoaded: true,
      };
    case actionTypes.IsCompaniesTableRefreshed:
      return {
        ...state,
        isCompaniesListLoaded: action.payload,
      };
    case actionTypes.SelectedCompany:
      return {
        ...state,
        selectedOperation: action.payload,
      };
    case actionTypes.FilterCompanies:
      return {
        ...state,
        companiesList: action.payload,
        isCompaniesListLoaded: true,
      };
    case actionTypes.SearchCompanies:
      return {
        ...state,
        isCompaniesListLoaded: true,
        companiesList: action.payload,
      };
    default:
      return state;
  }
};

export default hubspotReducer;
